<template>
  <div>
    <v-layout class="mt-2 mb-2">
      <v-flex xs6>
        <BuscaSimplesApi
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/disciplina"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi"
          id="identificadordisciplina" >
          <template slot-scope="propSlot">
            <span>{{ propSlot.item.descricaodisciplina }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" @change="$refs.buscaSimpleApi.busca = ''"/>
      </v-flex>
    </v-layout>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :acao="acao"
      :id="form.identificadordisciplina"
      :novo="novaDisciplina"
      :editar="editarDisciplina"
      :excluir="excluirDisciplina"
      :cancelar="cancelarDisciplina"
      :submit="onSubmit">
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaDisciplina" hover>
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
      <v-card>
        <v-card-text >
          <Input type="text" label="Código da Disciplina" v-model="form.identificadordisciplina" disabled />
          <Input type="text" label="Descrição da Disciplina" ref="focusCampo" v-model="form.descricaodisciplina" :disabled="acao == ''" :v="$v.form.descricaodisciplina" />
          <Input type="text" label="Sigla da Disciplina" v-model="form.sigladisciplina" :disabled="acao == ''" :v="$v.form.sigladisciplina"/>
          <Input type="text" label="Código Disciplina no Inep" v-model="form.codigodisciplinainep" :disabled="acao == ''" :v="$v.form.codigodisciplinainep" />
          <Validator label="Disciplina ministrada pela prefeitura?" :disabled="acao == ''" :v="$v.form.indicadisciplinaprefeitura">
            <Radio v-model="form.indicadisciplinaprefeitura" :disabled="acao == ''" val="N" label="Não"/>
            <Radio v-model="form.indicadisciplinaprefeitura" :disabled="acao == ''"  val="S" label="Sim"/>
          </Validator>

          <Validator label="Areas de conhecimento" block>
            <div v-for="area in areas" :key="area.id" style="flex: 100%" >
              <CheckBox
                v-model="form.areas_conhecimento"
                :label="area.descricaoareaconhecimento"
                :val="area.identificadorareaconhecimento"
                :disabled="acao == ''" />
            </div>
          </Validator>
        </v-card-text>
      </v-card>
    </FormBasico>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadordisciplina: '',
  descricaodisciplina: '',
  sigladisciplina: '',
  codigodisciplinainep: '',
  indicadisciplinaprefeitura: 'S',
  areas_conhecimento: [],
});

export default {
  name: 'Disciplina',
  components: {
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      buscarSelect: 'descricaodisciplina',
      areas: [],
      buscaOptions: [
        { value: 'identificadordisciplina', text: 'Código' },
        { value: 'descricaodisciplina', text: 'Descrição' },
        { value: 'sigladisciplina', text: 'Sigla' },
        { value: 'codigodisciplinainep', text: 'Código Inep' },
      ],
      formUltimo: {},
    };
  },
  validations: {
    form: {
      descricaodisciplina: {
        required, alphaSpace, maxLength: maxLength(50), minLength: minLength(4),
      },
      sigladisciplina: { maxLength: maxLength(3), alpha },
      codigodisciplinainep: { integer, maxLength: maxLength(10) },
      indicadisciplinaprefeitura: { required, alpha},
    },

  },
  created() {
    this.carregarAreasConhecimento();
  },
  methods: {
    tabelaDisciplina() {
      this.$root.$router.push({
        name: 'tabelas',
        params: {
          titulo: 'Disciplinas / Listar',
          rota_api: 'gerencial/disciplina/tabela',
          headers: [{ text: 'Identificador', value: 'identificadordisciplina', sortable: false },
            { text: 'Descrição', value: 'descricaodisciplina', sortable: false },
            { text: 'Sigla', value: 'sigladisciplina', sortable: false },
            {
              text: 'Áreas Conhecimento | Descrição', value: 'areas_conhecimento', sub_value: 'descricaoareaconhecimento', sortable: false, ordable: false,
            }],
        },
      });
    },
    novaDisciplina() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarDisciplina() {
      this.acao = 'editar';
    },
    cancelarDisciplina() {
      if (this.acao == 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async excluirDisciplina() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir esta diciplina?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/disciplina/${this.form.identificadordisciplina}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      api({
        method: (this.acao === 'novo') ? 'post' : 'put',
        url: `gerencial/disciplina${(this.acao === 'novo') ? '' : `/${this.form.identificadordisciplina}`}`,
        data: this.form,
      }).then((response) => {
        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.form = { ...response.data.results };
      }).catch((error) => {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      });
      this.$v.$reset();
    },
    encontrado(dados) {
      let areasConhecimento = [];
      if (typeof dados.areas_conhecimento !== 'undefined' && typeof dados.areas_conhecimento != null) { areasConhecimento = dados.areas_conhecimento.map(item => item.identificadorareaconhecimento); }

      this.form = setFormInicial();
      this.form = { ...dados, areas_conhecimento: areasConhecimento };
      this.formUltimo = { ...this.form };
      this.$refs.buscaSimpleApi.lista = [];
    },
    async carregarAreasConhecimento() {
      const { data } = await api.get('gerencial/areaconhecimento');

      this.areas = data.results;
    },
  },
};
</script>

<style>

</style>
